<template>
  <div class="mx-4">
    <div class="row py-4 pl-4">
      <div class="col-md-12">
        <div class="font-14 font-weight-bold">
          <span class="color-orange-light-2 mr-2">
            REDACCION DE CARTA
            <span class="align-sub">* * *</span>
          </span>
          <span class="color-dark-blue">
            ESPECIFIQUE Y DESGLOSE LOS OBJETIVOS DE SU INVESTIGACIÓN, EL TIPO DE
            METODOLOGÍA Y MUESTRA
          </span>
        </div>
      </div>
      <div class="col-12 pt-4">
        <!-- cHECKBOX WITH Para poder editar el contenido de la carta es necesario que deshabilite la confirmación de la misma-->
        <checkbox
          text="Para poder editar el contenido de la carta es necesario que deshabilite la confirmación de la misma"
          class="checkbox__extended d-flex"
          v-model="enabled"
          :disabled="readOnly"
        />
      </div>
    </div>
    <div class="row py-4 mx-2">
      <!-- Text Asunto y Text Area Contenido-->
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-12">
            <custom-input
              :label="$t('Subject')"
              v-model="subject"
              class="w-100 font-weight-bold color-dark-blue"
              :disabled="!this.isEditReadOnly || readOnly"
            />
          </div>
          <div class="col-md-12 mt-4">
            <!-- <custom-input :label="$t('Content')" class="w-100 font-weight-bold color-dark-blue" /> -->
            <span class="font-16 font-weight-bold">
              <span class="color-dark-blue">
                {{ $t('Content') }}
              </span>
            </span>
            <VueEditor
              v-if="editorReady"
              v-model="content"
              :disabled="!this.isEditReadOnly || readOnly"
              :editorToolbar="customToolbar"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//components
import Checkbox from 'CheckBox';
import CustomInput from 'CustomInput';
import { VueEditor } from 'vue2-editor';

//services
import {
  getRequest as _getRequest,
  submitAuthorizationLetter as _submitAuthorizationLetter,
  getAuthorizationLetter as _getAuthorizationLetter,
} from '@/services/app.api.js';
import { i18n } from '@/i18n';

//utils
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin';
//vuex types
import types from '@/store/modules/app/types.js';

export default {
  name: 'AuthorizationLetter',
  mixins: [alertMixin],
  components: {
    Checkbox,
    CustomInput,
    VueEditor,
  },
  watch: {},
  props: {
    iReadOnly: {
      type: Boolean,
      default: false,
    },
    isReadOnly: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    tabId: null,
    requestInfo: {},
    enabled: true,
    content:
      '<p><strong>ESPECIFIQUE Y DESGLOSE</strong></p><p><br></p><p><strong>LOS OBJETIVOS DE SU INVESTIGACIÓN,</strong></p><p><br></p><p><strong>EL TIPO DE METODOLOGÍA Y MUESTRA</strong></p>',
    subject: '',
    editorReady: false,
    // Toolbar con opciones compatibles con SSRS HTML rendering
    customToolbar: [
      [{ header: [1, 2, 3, false] }],
      ['bold', 'italic', 'underline', 'strike'],
      [
        { align: '' },
        { align: 'center' },
        { align: 'right' },
        { align: 'justify' },
      ],
      [{ list: 'ordered' }, { list: 'bullet' }],
      [{ indent: '-1' }, { indent: '+1' }],
      [{ color: [] }],
      ['clean'],
    ],
  }),
  computed: {
    businessId() {
      return this.$route.params.businessId;
    },
    isEditReadOnly() {
      return !this.enabled;
    },
    readOnly() {
      return this.iReadOnly || this.isReadOnly;
    },
  },
  async mounted() {
    await this.getLetter();
  },
  methods: {
    async getRequestInfo() {
      if (this.businessId) {
        this.requestInfo = (await _getRequest(this.businessId)).data;
        this.initializeSitemapInfo();
        this[types.SET_ITEM_MODEL](this.requestInfo);
      }
    },
    initializeSitemapInfo() {
      this[types.SET_SITEMAP_INFO]({
        routes: [
          i18n.t('Home'),
          `${i18n.t('ApplicationHeader.HeaderText')} #${this.businessId}`,
        ],
        request: {
          requestStatusId: this.requestInfo?.requestStatusId,
          requestStatusName: this.requestInfo?.requestStatusName,
          requestNumber: this.requestInfo?.requestNumber,
        },
      });
    },
    async onSaveHandler() {
      var payload = {
        requestNumber: this.businessId,
        body: this.content,
        subject: this.subject,
        isCompleted: this.enabled,
      };
      let saveResponse = await _submitAuthorizationLetter(payload).catch(
        (error) => {
          this.ShowToast('', error.response.data.message, 'error');
        }
      );

      if (saveResponse) {
        this.ShowToast(
          'Proceso exitoso',
          'El caso ha sido actualizado exitosamente.',
          'success'
        );
        await this.getRequestInfo();
      }
    },

    async onRefreshHandler() {
      await this.getRequestInfo();
      await this.getLetter();
    },
    async getLetter() {
      console.log('Call Letter');
      try {
        let { data } = await _getAuthorizationLetter(this.businessId);
        console.log(data);
        if (data) {
          if (data.body) this.content = data.body;
          this.subject = data.subject;
          this.enabled = data.isCompleted;
        }
      } catch (error) {
        console.log('Error loading letter:', error);
      }
      this.$nextTick(() => {
        this.editorReady = true;
      });
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/scss/components/action-button/index.scss';
@import '@/scss/bootstrap/_colors.scss';
@import '~vue2-editor/dist/vue2-editor.css';

.icon-view-size ::v-deep {
  width: auto !important;

  .dot {
    width: 35px !important;
    height: 35px !important;

    .title-icon {
      font-size: 15px !important;
    }
  }
}
</style>
